export default "__VITE_ASSET__CsdKq9FG__"